import Vue from 'vue'
import { decode, formatPrice } from 'utils/general'
import { mapState, mapActions } from 'vuex'
import { i18n } from 'lib/i18n.js'
import brandTagDisplay from 'mixins/brand-tag'
import dayjs from 'dayjs'
import dayjsBusinessDays from 'dayjs-business-days'
dayjs.extend(dayjsBusinessDays)

Vue.component('product-form', resolve => {
  Promise.all([
  ]).then(() => resolve({
    mixins: [brandTagDisplay],
    props: ['productJson', 'variants', 'parse', 'deliveryJson'],
    data () {
      return {
        activeOption: '',
        stockValue: 'madeOrder',
        deliveryHtml: '',
        stockStatus: '',
        stockInventory: '',
        outofstockStatus: '',
        activeCountryStatus: '',
        deliveryManufactureTime: 0,
        selectedCountry: '',
        inventryManagement: '',
        deliveryMessageStatus: false,
        options: [
          false,
          false,
          false
        ]
      }
    },
    computed: {
      ...mapState('product', [
        'product',
        'activeVariant',
        'engravingText'
      ]),
      productObject () {
        return this.parse ? JSON.parse(decode(this.productJson)) : this.productJson
      },
      deliveryObject () {
        const deliveryOpt = JSON.parse(decode(this.deliveryJson))
        return deliveryOpt
      },
      activeVariantPrice () {
        if (!this.activeVariant) {
          return false
        }
        if (this.activeVariant.compare_at_price) {
          return formatPrice(this.activeVariant.compare_at_price)
        }
        return formatPrice(this.activeVariant.price)
      },
      activeVariantDiscountPrice () {
        if (!this.activeVariant || !this.activeVariant.compare_at_price) {
          return false
        }
        return formatPrice(this.activeVariant.price)
      },
      engravingItem () {
        return __GLOBAL__.engravingItem.id
      }
    },
    mounted () {
      this.initialOptions()
      this.initDeliveryTime()
    },
    methods: {
      ...mapActions('global', [
        'openModal'
      ]),
      ...mapActions('cart', [
        'addToCart',
        'openCart'
      ]),
      ...mapActions('product', [
        'updateProduct',
        'setActiveVariant',
        'setEngraving'
      ]),
      initialOptions () {
        this.options = [this.activeVariant.option1, this.activeVariant.option2, this.activeVariant.option3]
      },
      initDeliveryTime () {
        const deliveryOpt = this.deliveryObject
        this.stockStatus = this.activeVariant.policy
        this.stockInventory = this.activeVariant.inventory_quantity
        this.outofstockStatus = this.activeVariant.inventory_quantity
        this.inventryManagement = this.activeVariant.management
        this.deliveryManufactureTime = deliveryOpt.manufactureTime
        this.activeCountryStatus = deliveryOpt.defaultCountry
        const storeActiveCountryStatus = localStorage.getItem('storeActiveCountryStatus')

        if (storeActiveCountryStatus) {
          this.activeCountryStatus = storeActiveCountryStatus
        } else {
          this.activeCountryStatus = deliveryOpt.defaultCountry
        }
        this.updateDeliveryTime()
      },
      async addProduct () {
        const id = this.activeVariant.id
        const properties = {}

        if (this.engravingText && this.engravingItem) {
          properties['Text'] = this.engravingText
          properties['_key'] = Date.now()
        }
        await this.addToCart({
          id,
          quantity: 1,
          properties,
          withProperties: true
        })

        if (this.engravingText && this.engravingItem) {
          await this.addToCart({
            id: this.engravingItem,
            quantity: 1,
            properties,
            withProperties: true
          })

          this.setEngraving('')
        }
      },
      getIndexByKey (keyValue) {
        let index = 1
        Object.keys(this.product.optionsWithValues).forEach((key, i) => {
          if (key === keyValue) {
            index = i
          }
        })

        return index
      },
      setOption (option, key) {
        this.options[this.getIndexByKey(key)] = option
        this.updateVariant()
      },
      onChange (event) {
        const key = event.target.options[event.target.options.selectedIndex].dataset.key
        const option = event.target.value
        this.options[this.getIndexByKey(key)] = option
        this.updateVariant()
      },
      updateVariant () {
        const filterEmptyValues = this.options.filter(x => x !== 'false')
        const variantTitle = filterEmptyValues.join(' / ')
        const variant = this.product.variants.find(variant => {
          return variant.title === variantTitle
        })

        if (variant) {
          this.setActiveVariant(variant)
          this.updateDeliveryMessage(variant)
        }
      },
      updateDeliveryMessage (variant) {
        this.stockStatus = variant.policy
        this.stockInventory = variant.inventory_quantity
        this.outofstockStatus = variant.inventory_quantity
        this.inventryManagement = this.activeVariant.management

        this.updateDeliveryTime()
      },
      onChangeCountry (event) {
        this.activeCountryStatus = event.target.value
        localStorage.setItem('storeActiveCountryStatus', this.activeCountryStatus)
        this.updateDeliveryTime()
      },
      updateDeliveryTime () {
        const deliveryOpt = this.deliveryObject
        const countryStatus = this.activeCountryStatus
        let shipingTime = ''
        let cstoretime = ''
        let cutOffTime = ''
        let statustime = ''
        let cutOffTimeAdded = ''

        cstoretime = deliveryOpt.cstoretime
        cutOffTime = deliveryOpt.cutofftime
        statustime = deliveryOpt.statustime

        const currentTime = new Date()
        // console.log(currentTime)
        const nowStr = currentTime.toISOString()
        // console.log(nowStr)
        const changeDayTimeStr = nowStr.split('T')[0] + 'T' + cutOffTime
        // console.log(changeDayTimeStr)
        const changeTimeDay = new Date(changeDayTimeStr)
        let differenceMs = changeTimeDay - currentTime

        if (differenceMs > 0) {
          const hours = parseInt(differenceMs / (60 * 60 * 1000))
          differenceMs %= (60 * 60 * 1000)

          const minutes = parseInt(differenceMs / (60 * 1000))
          differenceMs %= (60 * 1000)

          cutOffTimeAdded = 0
          console.log('Closing in ' + hours + ' hours, ' + minutes + ' minutes')
        } else {
          cutOffTimeAdded = 1
          console.log('Closed for today - Delivery in next day')
        }

        if (countryStatus === 'UK') {
          shipingTime = deliveryOpt.uk
        } else if (countryStatus === 'US') {
          shipingTime = deliveryOpt.us
        } else if (countryStatus === 'EU') {
          shipingTime = deliveryOpt.eu
        } else {
          shipingTime = deliveryOpt.row
        }

        if (this.stockInventory < 1 && this.stockStatus === 'continue') {
          const addDays = parseInt(shipingTime) + parseInt(this.deliveryManufactureTime)
          this.deliveryHtml = countryStatus + ' by ' + dayjs().businessDaysAdd(addDays + cutOffTimeAdded).format('MMMM DD')
        } else {
          this.deliveryHtml = countryStatus + ' by ' + dayjs().businessDaysAdd(shipingTime + cutOffTimeAdded).format('MMMM DD')
        }
        this.updateStockHtml()
      },
      updateStockHtml () {
        if ((this.stockInventory <= 0 && this.stockStatus === 'continue') || this.inventryManagement === '') {
          this.stockValue = 'madeOrder'
          this.deliveryMessageStatus = true
        } else if (this.stockInventory > 0) {
          if (this.stockInventory < 3) this.stockValue = 'lowStock'
          else this.stockValue = 'inStock'
          this.deliveryMessageStatus = true
        } else if (this.outofstockStatus <= 0) {
          this.stockValue = 'Outofstock'
          this.deliveryMessageStatus = true
        } else {
          this.deliveryMessageStatus = false
        }
      },
      isSizeOption (key) {
        return (key.toLowerCase() === 'size')
      }
    },
    i18n
  }))
})
